export default __webpack_public_path__ + "static/media/Memory-Matching-Game.91ab8fcf.gif";